import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { NewAccountModal } from "./components/modals/NewAccountModal";
import { NewPortfolioModal } from "./components/modals/NewPortfolioModal";
import { EditPortfolioModal } from "./components/modals/EditPortfolioModal";
import { NewPropertyModal } from "./components/modals/NewPropertyModal";
import { EditPropertyModal } from "./components/modals/EditPropertyModal";
import Login from "./pages/Login";
import PrivateRoute from "./components/PrivateRoute";
import Accounts from "./pages/Accounts";
import Properties from "./pages/Properties";
import SystemStatus from "./pages/SystemStatus";
import AccountDetails from "./pages/AccountDetails";
import { NewUserModal } from "./components/modals/NewUserModal";
import type { User } from "firebase/auth";

interface AppRoutesProps {
  user: User | null;
}

const AppRoutes = ({ user }: AppRoutesProps) => {
  const location = useLocation();
  const state = location.state as { background?: Location };
  const backgroundLocation = state?.background;

  return (
    <>
      <Routes location={backgroundLocation || location}>
        <Route
          path="/login"
          element={user ? <Navigate to="/accounts" /> : <Login />}
        />
        <Route path="/" element={<Navigate to="/accounts" />} />
        <Route
          path="/accounts"
          element={
            <PrivateRoute user={user}>
              <Accounts user={user} />
            </PrivateRoute>
          }
        />
        <Route
          path="/accounts/:accountName"
          element={
            <PrivateRoute user={user}>
              <AccountDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/system-status"
          element={
            <PrivateRoute user={user}>
              <SystemStatus />
            </PrivateRoute>
          }
        />
        <Route
          path="/properties"
          element={
            <PrivateRoute user={user}>
              <Properties user={user} />
            </PrivateRoute>
          }
        />
      </Routes>
      {backgroundLocation && (
        <Routes>
          {/* Account modal routes */}
          <Route path="/modals/account/create" element={<NewAccountModal />} />
          {/* Portfolio modal routes */}
          <Route
            path="/modals/portfolio/create"
            element={<NewPortfolioModal />}
          />
          <Route
            path="/modals/portfolio/:id/edit"
            element={<EditPortfolioModal />}
          />
          {/* Property modal routes */}
          <Route
            path="/modals/property/create"
            element={<NewPropertyModal />}
          />
          <Route
            path="/modals/property/:id/edit"
            element={<EditPropertyModal />}
          />
          {/* User modal routes */}
          <Route path="/modals/user/create" element={<NewUserModal />} />
        </Routes>
      )}
    </>
  );
};

export default AppRoutes;
